/**
 * Endpoint 4 — GET store/app (research/07 §4; REQ-CART-6). 204 is deliberately
 * NOT handled: response.json() is called unconditionally and the cart chain
 * rejects silently (REQ-API-5). Wholesale assignment to
 * cpc_fasterCheckoutConfig.
 */
import { appState } from "../state/app-state";

export async function LoadStoreConfig(): Promise<void> {
  var url = appState.baseCalculatorNewApiUrl + "store/app?shop=" + appState.cpc_shopUrl;

  await fetch(url)
    .then((response) => response.json())
    .then((json) => {
      appState.cpc_fasterCheckoutConfig = json;
    });
}
